"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isMessage = isMessage;
exports.isVersion = isVersion;
exports.isInitMessage = isInitMessage;
exports.isCommandResponseMessage = isCommandResponseMessage;
exports.isCommandMessage = isCommandMessage;
exports.isNotificationMessage = isNotificationMessage;
exports.isHandshakeMessage = isHandshakeMessage;
const guid = require("guid");
const Notifications_1 = require("../contract/Notifications");
const MessageTypes_1 = require("./interface/MessageTypes");
const expectedEmptyNotifications = new Set([
    Notifications_1.NotificationId.EditButtonClicked,
    Notifications_1.NotificationId.EditInDesktopButtonClicked,
    Notifications_1.NotificationId.WorkbookPublished,
    Notifications_1.NotificationId.WorkbookReadyToClose,
    Notifications_1.NotificationId.ReadyToReceiveAuthToken,
]);
/* tslint:disable no-any */
function isMessage(data) {
    if (!data) {
        return false;
    }
    const message = data;
    if (!message || !message.msgGuid || !message.msgType) {
        return false;
    }
    if (!guid.isGuid(message.msgGuid)) {
        return false;
    }
    if (typeof message.msgType !== 'string') {
        return false;
    }
    const messageTypes = [
        MessageTypes_1.MessageType.Command,
        MessageTypes_1.MessageType.CommandResponse,
        MessageTypes_1.MessageType.Initialize,
        MessageTypes_1.MessageType.Notification,
        MessageTypes_1.MessageType.Handshake,
    ];
    if (messageTypes.indexOf(message.msgType) < 0) {
        return false;
    }
    return true;
}
function isVersion(versionNumber) {
    if (!versionNumber) {
        return false;
    }
    const v = versionNumber;
    if (typeof v !== 'object') {
        return false;
    }
    if (typeof v.fix !== 'number' || typeof v.minor !== 'number' || typeof v.major !== 'number') {
        return false;
    }
    return true;
}
function isInitMessage(message) {
    if (!isMessage(message)) {
        return false;
    }
    const initMessage = message;
    if (initMessage.msgType !== MessageTypes_1.MessageType.Initialize) {
        return false;
    }
    if (!initMessage.apiVersion || !isVersion(initMessage.apiVersion)) {
        return false;
    }
    if (!initMessage.crossFrameVersion || !isVersion(initMessage.crossFrameVersion)) {
        return false;
    }
    return true;
}
function isCommandResponseMessage(message) {
    if (!isMessage(message)) {
        return false;
    }
    const crMessage = message;
    if (crMessage.msgType !== MessageTypes_1.MessageType.CommandResponse) {
        return false;
    }
    if (!guid.isGuid(crMessage.commandGuid)) {
        return false;
    }
    if (!crMessage.data && !crMessage.error) {
        return false;
    }
    return true;
}
function isCommandMessage(message) {
    if (!isMessage(message)) {
        return false;
    }
    const commandMessage = message;
    if (commandMessage.msgType !== MessageTypes_1.MessageType.Command) {
        return false;
    }
    if (!commandMessage.parameters || typeof commandMessage.parameters !== 'object') {
        return false;
    }
    if (!commandMessage.verbId || typeof commandMessage.verbId !== 'string') {
        return false;
    }
    return true;
}
function isNotificationMessage(message) {
    if (!isMessage(message)) {
        return false;
    }
    const notificationMessage = message;
    if (notificationMessage.msgType !== MessageTypes_1.MessageType.Notification) {
        return false;
    }
    if (!notificationMessage.data && !expectedEmptyNotifications.has(notificationMessage.notificationId)) {
        return false;
    }
    if (!notificationMessage.notificationId || typeof notificationMessage.notificationId !== 'string') {
        return false;
    }
    return true;
}
function isHandshakeMessage(message) {
    if (!isMessage(message)) {
        return false;
    }
    const handshakeMessage = message;
    if (handshakeMessage.msgType !== MessageTypes_1.MessageType.Handshake) {
        return false;
    }
    return true;
}
//# sourceMappingURL=MessageTypeChecks.js.map